import { apimCall, publicShareApimCall } from './api';
import { appContext } from '../AppContext';
import { isGuid } from './utility';
import { getField } from '../formeditor/selectors';
import { FieldTypes } from './constants';
import { GoFormzServices } from '../AppSettings';
import { RootState } from 'gf-types';

export async function getNextAutoNumber(key: string, seed?: number): Promise<AutoNumberResponse> {
  const state = appContext.store.getState();
  const sharedAccessToken = state.formeditor.sharedAccessToken;
  const previewMode = state.formeditor.previewMode;

  if (previewMode) {
    return { value: getPreviewValue(state, key, seed) };
  }

  try {
    const response = sharedAccessToken
      ? await publicShareApimCall(`/autonumbers/${key}${seed ? `?seed=${seed}` : ''}`)
      : await apimCall(GoFormzServices.TemplateService, `/autonumbers/${key}${seed ? `?seed=${seed}` : ''}`);
    return response.data;
  } catch (error) {
    return { value: `[##AUTO##]${key}` };
  }
}

function getPreviewValue(state: RootState, key: string, seed: number): string {
  let previewValue: string = seed?.toString();
  if (!previewValue && isGuid(key)) {
    const field = getField(state.formeditor.template, key);
    if (field && field.type === FieldTypes.AutoNumber) {
      previewValue = field.seed?.toString();
    }
  }
  if (!previewValue) {
    previewValue = '1000';
  }
  return previewValue;
}

type AutoNumberResponse = {
  value: string;
};
